import type { FC } from 'react'
import { BrandLogo, cn } from '@yanolja-rnd/nol-design-system'

export interface FooterProps {
  /**
   * 화면 하단 고정 CTA 여부 — footer가 가리지 않게 safe-area 를 확보한다
   * (고정바가 없는 지면은 false 유지 — 불필요한 하단 여백 방지)
   */
  hasBottomCta?: boolean
  /**
   * 하단 고정 CTA 높이가 동적인 지면에서, footer 콘텐츠가 CTA/GoToTop 위로 보이도록
   * 확보할 하단 여백(px). 지정 시 `hasBottomCta` 의 정적 pb 대신 이 값(+safe-area)을 쓴다.
   * (예: 장바구니 구매바는 "총건/금액 행 + 버튼"이라 156px 정적값으로는 부족)
   */
  bottomReservePx?: number
  className?: HTMLDetailsElement['className']
}

export const Footer: FC<FooterProps> = ({
  className = '',
  hasBottomCta = false,
  bottomReservePx,
}) => {
  return (
    <footer
      style={
        bottomReservePx != null
          ? { paddingBottom: `calc(${bottomReservePx}px + var(--safe-area-bottom))` }
          : undefined
      }
      className={cn(
        'mx-auto flex bg-fill-neutral-weak px-16 pt-16',
        'w-full max-w-pf-mobile pf-pc:max-w-full pf-pc:px-0 pf-pc:pb-112',
        // 모바일 하단 여백 (PC는 pb-112). CTA 지면은 그 위 Gototop 영역까지 확보
        // 156px = (CTA + gap) 96 + 버튼(min-h-44) 44 + (Gototop ↔ footer gap) 16
        hasBottomCta ? 'pb-[calc(156px_+_var(--safe-area-bottom))]' : 'pb-92',
        className
      )}
    >
      <div className={'mx-auto flex w-full max-w-pf-pc flex-col gap-12 pf-pc:px-40'}>
        {/*로고*/}
        <div className="py-16">
          <BrandLogo theme="gray_medium" className="h-18 w-49" />
        </div>

        {/*푸터 메시지*/}
        <div className="text-text-neutral-sub typography-caption-11-regular-multiline">
          (주)놀유니버스는 통신판매 중개자로서 통신판매의 당사자가 아니며 상품의 예약, 이용 및 환불
          등과 관련한 의무와 책임은 각 판매자에게 있습니다.
        </div>
      </div>
    </footer>
  )
}
